import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const slides = [
  {
    title: "Web Hosting",
    text: "Provides every customer with the necessary tools to get a fully-functional Linux website up and running as quickly as possible.",
    img: "/images/banner1.webp",
    priceColor: "bg-pink-500",
  },
  {
    title: "WordPress Hosting",
    text: "Provides every customer with the necessary tools to get a fully-functional Linux website up and running as quickly as possible.",
    img: "/images/banner2.webp",
    priceColor: "bg-red-500",
  },
  {
    title: "Transfer Domain to Us",
    text: "Provides every customer with the necessary tools to get a fully-functional Linux website up and running as quickly as possible.",
    img: "/images/banner3.webp",
    priceColor: "bg-yellow-500",
  },
  {
    title: "Domain Register",
    text: "Provides every customer with the necessary tools to get a fully-functional Linux website up and running as quickly as possible.",
    img: "/images/banner4.webp",
    priceColor: "bg-blue-500",
  },
];


export default function HomeSlider() {
  return (
    <section className="relative w-full">
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        // navigation
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        className="h-[80vh] w-full"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-full">
              {/* Background Image */}
              <img
                src={slide.img}
                alt={slide.title}
                className="absolute w-full h-full object-cover"
              />

              {/* Blueish gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-blue-900/60 via-blue-800/50 to-black/60 mix-blend-multiply"></div>

              {/* Optional: Slight blur/brightness adjustment */}
              <div className="absolute inset-0 backdrop-brightness-90"></div>

              {/* Text content */}
              <div className="relative z-10 flex flex-col items-center justify-center h-full text-center text-white px-4">
                <h2 className="text-4xl md:text-6xl font-bold mb-4">
                  {slide.title}
                </h2>
                <p className="max-w-2xl text-lg mb-6 opacity-90">
                  {slide.text}
                </p>
                <div className="flex gap-4 justify-center">
                  {/* <a
                    href="#"
                    className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-3 rounded-lg transition flex items-center gap-2"
                  >
                    <i className="fa fa-external-link"></i> Read More
                  </a>
                  <a
                    href="#"
                    className={`${slide.priceColor} hover:opacity-90 text-white px-6 py-3 rounded-lg transition flex items-center gap-2`}
                  >
                    <i className="icon-basket"></i> $29.99
                  </a> */}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
